import { supabase } from "@/integrations/supabase/client";

type AllowedTable =
  | "shared_links"
  | "evidence_items"
  | "user_roles"
  | "user_permission_overrides"
  | "api_secrets"
  | "mfa_factors";

interface GatewayOptions {
  table: AllowedTable;
  operation: "insert" | "update" | "delete";
  data?: Record<string, unknown>;
  match?: Record<string, unknown>;
  mfa_token?: string;
}

interface GatewayResponse<T = unknown> {
  success: boolean;
  data?: T[];
  error?: string;
  mfa_required?: boolean;
}

/**
 * Routes writes to sensitive tables through the secure-gateway edge function.
 * These tables have write-deny RLS policies, so direct client writes will fail.
 * The gateway validates auth, admin role, and MFA before writing with service_role.
 */
export async function gatewayWrite<T = unknown>(
  options: GatewayOptions
): Promise<GatewayResponse<T>> {
  const { data, error } = await supabase.functions.invoke<GatewayResponse<T>>(
    "secure-gateway",
    {
      body: options,
    }
  );

  if (error) {
    return { success: false, error: error.message };
  }

  return data ?? { success: false, error: "No response from gateway" };
}
